import { useLocation } from 'react-router-dom';
import { usePageTitle as usePageTitleBase } from '@lucid/lego';
import type { PageTitleEntry } from '@lucid/lego';

const APP_NAME = 'Lucid Partner Portal';

/**
 * Ordered from most-specific to least-specific so the first match wins.
 */
const PAGE_TITLE_MAP: PageTitleEntry[] = [
  // Admin
  { pattern: /\/admin\/workspace-access/, title: 'Workspace Access' },
  { pattern: /\/admin\/portal-setup/, title: 'Portal Setup' },
  { pattern: /\/admin\/test-drive-scheduler/, title: 'Test Drive Management' },
  // Prospect Desk
  { pattern: /\/test-drive-calendar/, title: 'Test Drive Calendar' },
  { pattern: /\/prospect-desk\/create-new-prospect/, title: 'Create New Prospect' },
  { pattern: /\/prospect-desk\/test-drive-bookings/, title: 'Test Drive Bookings' },
  { pattern: /\/prospect-desk/, title: 'Prospect Desk' },
  // Order Hub
  { pattern: /\/order-hub\/order-builder\/checkout/, title: 'Checkout' },
  { pattern: /\/order-hub\/order-builder/, title: 'Order Builder' },
  { pattern: /\/order-hub\/manage-orders/, title: 'Manage Orders' },
  { pattern: /\/order-hub\/order-desk/, title: 'Order Desk' },
  // Top-level
  { pattern: /^\/?([a-z]{2}-[a-z]{2})?$/, title: 'Dashboard' },
];

/**
 * Sets the document title to `Lucid Partner Portal - {Page Name}` based on
 * the current route. Falls back to the app name alone when no match is found.
 * Call once in LayoutWrapper.
 * @hook
 */
const usePageTitle = (): void => {
  const { pathname } = useLocation();
  usePageTitleBase(APP_NAME, PAGE_TITLE_MAP, pathname);
};

export default usePageTitle;
